import { render, staticRenderFns } from "./LoginAppFooter.vue?vue&type=template&id=c4dfcb16&"
import script from "./LoginAppFooter.vue?vue&type=script&lang=js&"
export * from "./LoginAppFooter.vue?vue&type=script&lang=js&"
import style0 from "./LoginAppFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports